import * as React from "react";
import {Container,Row, Col} from "reactstrap";
import Footer from "./Footer";
import "./About.css";

/**
 * 
 * 
 * @export
 * @class App
 * @extends {React.Component<{}, {}>}
 */
export default class About extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);       
    }  
    render() {
        return (           
            <Container style= {{paddingTop:50}} id = "aboutUs" className = "header-container1">
                <Row>About Us</Row>
                <Row >
                    <Col sm="10" >     
                        Chennai Jigarthanda had been started of with the inspiration of Famous Madurai Jigarthanda.
                        We server customers with love and we have our own unique taste. Our product is purely home 
                        made with purified milk. We undertake party orders for which price template has been listed.
                        In addition we also server fruit salad for parties.                        
                    </Col>
                </Row>            
                
            </Container>
        );
    }
}






// WEBPACK FOOTER //
// ./src/components/views/About.tsx